import React, { useState } from 'react';
import {
  Box, Typography, Button, Grid, Tabs, Tab, Avatar,
  Chip, LinearProgress,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { PageHeader, SectionCard, StatusBadge, colors } from '@kangaroo/ui';
import { PAGE_ICONS } from '../../lib/pageIcons';

const NOTES = [
  { driver: 'Brayden St.Cyr', a: 'B', focus: ['Corner Exit Speed', 'Brake Release Timing'], sentiment: 'positive' as const, date: 'May 18, 2024', content: 'Great improvement in sector 2 today. Focus on brake release timing entering turn 5.' },
  { driver: 'Bryce St.Cyr',   a: 'B', focus: ['Apex Consistency', 'Throttle Control'],      sentiment: 'neutral'  as const, date: 'May 18, 2024', content: 'Consistency improving. Keep working on hitting the apex on turns 3 and 4.' },
  { driver: 'Luca Marini',    a: 'L', focus: ['Overtaking', 'Racecraft'],                   sentiment: 'needsWork'as const, date: 'May 17, 2024', content: 'Need to work on defensive driving and timing overtaking moves.' },
];

const DRILLS = [
  { driver: 'Brayden St.Cyr', category: 'Braking',     title: 'Late Braking Drill',      due: 'May 25', completed: false },
  { driver: 'Bryce St.Cyr',   category: 'Corner Exit', title: 'Throttle Progression',    due: 'May 25', completed: true  },
  { driver: 'Luca Marini',    category: 'Overtaking',  title: 'Side-by-side Positioning',due: 'May 22', completed: false },
];

export function CoachingPage() {
  const [tab, setTab] = useState(0);

  return (
    <Box>
      <PageHeader
        title="Coaching"
        subtitle="Driver notes, drills, and development plans"
        icon={PAGE_ICONS.coaching}
        mb={3}
        actions={<Button variant="contained" startIcon={<AddIcon />} size="small" sx={{ fontWeight: 700 }}>Add Note</Button>}
      />

      <Tabs value={tab} onChange={(_: React.SyntheticEvent, v: number) => setTab(v)} sx={{ mb: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
        {['Notes', 'Drills', 'Development Plans'].map((t) => <Tab key={t} label={t} sx={{ fontSize: '0.8rem', minHeight: 40 }} />)}
      </Tabs>

      {tab === 0 && (
        <Grid container spacing={2}>
          {NOTES.map((note, i) => (
            <Grid item xs={12} md={6} key={i}>
              <SectionCard
                action={<StatusBadge status={note.sentiment} />}
              >
                <Box sx={{ display: 'flex', gap: 1.5, mb: 1.5 }}>
                  <Avatar sx={{ width: 32, height: 32, fontSize: '0.75rem' }}>{note.a}</Avatar>
                  <Box>
                    <Typography variant="body2" fontWeight={600}>{note.driver}</Typography>
                    <Typography variant="caption" color="text.secondary">{note.date}</Typography>
                  </Box>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, fontSize: '0.825rem' }}>
                  {note.content}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
                  {note.focus.map((f) => (
                    <Chip key={f} label={f} size="small"
                      sx={{ bgcolor: `${colors.primary[500]}22`, color: colors.primary[400], fontSize: '0.7rem', height: 20 }}
                    />
                  ))}
                </Box>
              </SectionCard>
            </Grid>
          ))}
        </Grid>
      )}

      {tab === 1 && (
        <Grid container spacing={2}>
          {DRILLS.map((d, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <SectionCard>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Chip label={d.category} size="small" sx={{ bgcolor: `${colors.primary[500]}22`, color: colors.primary[400], fontSize: '0.7rem' }} />
                  {d.completed
                    ? <Chip label="Completed" size="small" sx={{ bgcolor: `${colors.success.main}22`, color: colors.success.main, fontSize: '0.7rem' }} />
                    : <Typography variant="caption" color="text.secondary">Due {d.due}</Typography>
                  }
                </Box>
                <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>{d.title}</Typography>
                <Typography variant="caption" color="text.secondary">{d.driver}</Typography>
              </SectionCard>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}
